// import store from '../index'
import { activitySelect } from "@/api/activity";

export default {
  namespaced: true,
  state: () => ({
    equipmentSelectVO: [],
    coachLevalVO: [],
    movingSelectVO: [],
  }),
  mutations: {
    set_select: (state, data) => {
      state.coachLevalVO = Array.from(
        new Set(
          data.coachSelectVO.reduce((init, item) => {
            if (item.level) init.push(item.level);
            return init;
          }, [])
        )
      );
      state = Object.assign(state, data);
    },
  },
  actions: {
    async getSelect({ commit, state }) {
      await activitySelect().then(data => {
        commit("set_select", data);
      });
    },
  },
};
